import { IPersonaProps, ITag } from '@fluentui/react';
import { DimensionFile_Unit, FilterEF_Operator, Indici_FormMode, Protocol_State, Protocol_Type, ProtocolloAreaDiLavoroEF_State, Search_QueryOperator, Wizard_Mode } from '../enums';
import { IChoiceField, IDateTimeField, IField, IFile, IAutocompleteField, IProtocol, ITextField, IUser, IUserField, INumberField, IFascicolo, IFilterEF, IVisibilita, IUor, IProtocolEF, ICurrencyField } from '../interfaces';
import moment from 'moment';
import 'moment/locale/it';
import Utilities from './utilities';
import { start } from 'repl';

export default class AppUtilities {


    static FieldFormatDateInUniversalString(dateTimeField: IDateTimeField | undefined): string {
        var result = "-";
        if (dateTimeField && dateTimeField.internalValue) {
            try {

                moment.locale('it');
                let dateOnly = dateTimeField.dateOnly ? true : false;
                var dateObjectd = moment(dateTimeField.internalValue.toString());

                result = dateObjectd.format("YYYY-MM-DDTHH:mm:ssZ");


            }
            catch { }
        }
        return result;
    }

    static FormatDate(dateValue, dateOnly: boolean) {
        var result = "-";

        if (dateValue === undefined) {
            return result;
        }
        // Esempio per specificare più formattazioni
        // var dateObjectd = moment(stringDateValue, [moment.defaultFormat, 'DD/MM/YYYY hh:mm'])

        var dateObjectd = moment(dateValue.toString());
        // Esempi formattazione
        // moment.locale();         // it
        // moment().format('LT');   // 17:49
        // moment().format('LTS');  // 17:49:50
        // moment().format('L');    // 25/06/2021
        // moment().format('l');    // 25/6/2021
        // moment().format('LL');   // 25 giugno 2021
        // moment().format('ll');   // 25 giu 2021
        // moment().format('LLL');  // 25 giugno 2021 17:49
        // moment().format('lll');  // 25 giu 2021 17:49
        // moment().format('LLLL'); // venerdì 25 giugno 2021 17:49
        // moment().format('llll'); // ven 25 giu 2021 17:50

        if (dateOnly) {
            result = dateObjectd.format('L');
        }

        else {
            result = dateObjectd.format('LLL');
        }
        return result;

    }

    static FormatDateRange(dateTimeField: IDateTimeField) {
        var result;
        let dateValue = dateTimeField.internalValue !== undefined && dateTimeField.internalValue !== null ? [...dateTimeField.internalValue] : undefined;

        if (dateTimeField && dateValue) {

            if (dateValue.length === 2) {

                const sortedDates = dateValue.sort((a, b) => {
                    return a.getTime() - b.getTime();
                });

                var startDate = moment(sortedDates[0].toString());
                var endDate = moment(sortedDates[1].toString());

                if (startDate.valueOf() !== endDate.valueOf()) {
                    result = `${startDate.format('L')} - ${endDate.format('L')}`;
                } else {
                    result = startDate.format('L');
                }

            } else if (dateValue.length === 1) {
                var date = moment(dateValue[0].toString());
                result = date.format('L');
            }
        }
        return result;
    }

    static FieldFormatDate(dateTimeField: IDateTimeField | undefined): string {
        var result = "-";
        if (dateTimeField && dateTimeField.internalValue) {
            try {

                moment.locale('it');
                let dateOnly = dateTimeField.dateOnly ? true : false;
                result = this.FormatDate(dateTimeField.internalValue, dateOnly);


            }
            catch { }
        }
        return result;
    }

    static FieldFormatChoice(choiceField: IChoiceField | undefined): string {
        var result = "-";
        if (choiceField && choiceField.internalValue) {
            if (Array.isArray(choiceField.internalValue)) {
                result = choiceField.internalValue.join('; ') + (choiceField.multi ? ';' : '');
            }
            else {
                result = choiceField.internalValue;
            }

        }
        return result;
    }

    static FieldFormatLookup(autocompleteField: IAutocompleteField | undefined): string {
        var result = "-";
        if (autocompleteField && autocompleteField.internalValue) {
            if (Array.isArray(autocompleteField.internalValue)) {
                result = autocompleteField.internalValue.map(el => el.name).join('; ') + (autocompleteField.multi ? ';' : '');
            }
            else {
                result = autocompleteField.internalValue;
            }
        }

        return result;
    }

    static FieldFormatUser(campo): string {
        var result = "-";
        if (campo && campo.internalValue) {
            if (Array.isArray(campo.internalValue)) {
                result = campo.internalValue.map(el => el.text).join('; ') + (campo.multi ? ';' : '');
            }
            else {
                try {
                    //In TypeScript, filter(Boolean) viene utilizzato per rimuovere i valori falsy da un array. I valori falsy includono false, null, undefined, 0, "" (stringa vuota), e NaN.
                    const internalValueSplitArray = campo.internalValue.split(';').filter(Boolean);
                    let namesArray: string[] = [];

                    for (const userInfo of internalValueSplitArray) {
                        const match = /([^<]+)<([^>]+)>/.exec(userInfo.trim());
                        if (match) {
                            const text = match[1].trim();
                            namesArray.push(text);
                        } else {
                            namesArray.push(userInfo);

                        }
                    }
                    if (namesArray.length > 0) {
                        result = namesArray.join('; ') + (campo.multi ? ';' : '');
                    }
                }
                catch { }
            }

        }
        return result;
    }

    static FieldFormatBoolean(field: IField | undefined): string {
        var result = "-";

        if (field) {
            result = field.internalValue && field.internalValue === true ? "Sì" : "No";
        }

        return result;
    }

    static FieldFormatCurrency(field: ICurrencyField | undefined): string {
        var result = "-";
        if (field && field.internalValue) {
            let newVal: any = Utilities.TryParseToNumber(field.internalValue);

            try {
                var localeName = field.localeName ? field.localeName : "it-IT";
                var optionsCurrency: Intl.NumberFormatOptions = { style: 'decimal', useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 };
                result = new Intl.NumberFormat(localeName, optionsCurrency).format(newVal);
            }
            catch { }
        }

        return result;
    }

    static FieldFormatNumber(field: INumberField | undefined): string {
        var result = "-";

        if (field && field.internalValue) {
            let newVal: any = Utilities.TryParseToNumber(field.internalValue);

            try {
                var maxDecimal = field.decimals && field.decimals > 0 ? field.decimals : 20; //Possible values are from 0 to 20;
                var optionsCurrency: Intl.NumberFormatOptions = { style: 'decimal', useGrouping: false, minimumFractionDigits: 0, maximumFractionDigits: maxDecimal };
                result = new Intl.NumberFormat("it-IT", optionsCurrency).format(newVal);
            }
            catch { }

        }
        return result;
    }

    static FormatProtocolNumber(protocol: IProtocol) {
        //aggiunge gli zeri prima del numero
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        return `${zeroPad(protocol.numeroProtocollo, 8)}/${protocol.annoProtocollo}`;
    }



    static CapitalizeString(value: string) {
        if (value) {
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        }
        return value;
    }

    static GetInizialiFromUserName(value: string | undefined) {
        let iniziali = '-';
        if (value) {
            let words = value.split(' ');
            if (words[0])
                iniziali = words[0].slice(0, 1);
            if (words[1])
                iniziali = iniziali + words[1].slice(0, 1);
        }
        return iniziali;
    }


    static GetFilesizeInKBFromBase64(base64: string) {
        var sizeInBytes = 4 * Math.ceil((base64.length / 3)) * 0.5624896334383812;
        return sizeInBytes / 1024;
    }


    static GetDimensionFileString = (file: IFile) => {

        if (!file.dimension || file.dimensionUnit === undefined || file.dimensionUnit === null)
            return undefined;

        let dimension = file.dimension ? file.dimension : 0;


        let dimensionUnit = file.dimensionUnit;

        if (typeof file.dimensionUnit == 'string') {
            dimensionUnit = DimensionFile_Unit[file.dimensionUnit];
        }
        var enumLength = 0
        for (let element in DimensionFile_Unit) {
            if (isNaN(Number(element))) {
                enumLength++
            }
        }
        while (dimensionUnit <= enumLength && dimension >= 1024) {
            dimension = dimension / 1024;
            dimensionUnit++;
        }
        if (dimensionUnit < 2)
            return `${Math.round(dimension)} ${DimensionFile_Unit[dimensionUnit]}`;
        else {
            var localeName = "it-IT";
            var optionsCurrency = { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 };
            let dim = new Intl.NumberFormat(localeName, optionsCurrency).format(dimension);

            return `${dim} ${dimensionUnit ? DimensionFile_Unit[dimensionUnit] : ''}`;

        }

    }



    static updateFieldInList(fields: IField[], fieldInternalName: string, updatedField: Partial<IField>) {

        let filedIndex = fields.findIndex(el => el.internalName == fieldInternalName);
        if (filedIndex >= 0) {
            let field = { ...fields[filedIndex] } as IChoiceField;
            fields[filedIndex] = { ...field, ...updatedField };
        }

    }

    static fixInternalValueForProtocolStateEnum(protState: Protocol_State) {
        switch (protState) {
            case Protocol_State.Undefined: return "";
            case Protocol_State.Acquisito: return "Acquisito";
            case Protocol_State.Allocato: return "Allocato";
            case Protocol_State.Annullato: return "Annullato";
            case Protocol_State.InCreazione: return "InCreazione";
            case Protocol_State.InCreazioneDaMail: return "InCreazioneDaMail";
            case Protocol_State.Prenotato: return "Prenotato";
            case Protocol_State.Protocollato: return "Protocollato";
        }
    }
    static fixInternalValueForProtocolTypeEnum(protType: Protocol_Type) {
        switch (protType) {
            case Protocol_Type.Undefined: return "";
            case Protocol_Type.DocumentoInEntrata: return "Documento in entrata";
            case Protocol_Type.DocumentoInterno: return "Documento interno";
            case Protocol_Type.DocumentoInUscita: return "Documento in uscita";
        }
    }

    static fixFieldsForm(mode: Indici_FormMode, fields: IField[]): IField[] {
        let fixedFields: IField[] = [];
        switch (mode) {


            case Indici_FormMode.Create:
                fields?.forEach(f => {
                    if (!f.system && !f.readonly && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza') {

                        fixedFields.push(f);
                    }
                });
                break;

            case Indici_FormMode.Edit:
                /// per avere prima i campi readonly e poi quelli editabili
                /// estraggo prima i readonly e poi gli editabili e poi li concateno
                let readOnlyFields = fields.filter(f => f.readonly && !f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
                let noReadOnlyFields = fields.filter(f => !f.readonly && !f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
                fixedFields = [...readOnlyFields, ...noReadOnlyFields];
                break;

            case Indici_FormMode.ReadOnly:
                fields?.forEach(f => {
                    if (!f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza') {
                        let _field = { ...f };
                        _field.readonly = true;
                        fixedFields.push(_field);
                    }
                });
                break;

            case Indici_FormMode.Search:
                fields?.forEach(f => {
                    if (!f.system && f.internalName !== 'Title' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza') {
                        let _field = { ...f };
                        _field.readonly = false;
                        _field.required = false;


                        if (f.controlType === 'calendar') {
                            let dateTimeField: IDateTimeField = { ..._field, rangeMode: true }
                            fixedFields.push(dateTimeField);
                        }
                        //else if (f.controlType === 'dropdown') {
                        //    let choiceField: Partial<IChoiceField> = { ..._field, multi: true }
                        //    fixedFields.push(choiceField);
                        //}
                        //else if (f.controlType === 'autocomplete') {
                        //    let lookupField: Partial<ILookupField> = { ..._field, multi: true }
                        //    fixedFields.push(lookupField);
                        //}
                        //else if (f.controlType === 'autocompleteUser') {
                        //    let userField: Partial<IUserField> = { ..._field, multi: true }
                        //    fixedFields.push(userField);
                        //}
                        else {
                            fixedFields.push(_field);
                        }
                    }


                });
                break;
            case Indici_FormMode.CreateForwardRule:
                fields?.forEach(f => {
                    if (!f.system && f.internalName !== 'Title' && f.internalName !== 'ID' && f.internalName !== 'Anno' &&
                        f.internalName !== 'NumeroProtocollo' && f.internalName !== 'DataProtocollo' && f.internalName !== 'Protocollo' &&
                        f.internalName !== 'PagineDocumento' && f.internalName !== 'StatoProtocollo' && f.internalName !== 'Protocollista' &&
                        f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza') {
                        fixedFields.push(f);
                    }
                });
                break;

        }
        return fixedFields;
    }

    static fixFieldsInternalValueForCreateAndUpdateProtocol(fields: IField[], isCreate: boolean): IField[] {
        const fixedFields = fields.map((item, index) => {
            return this.fixInternalValueForCreateAndUpdateProtocol(item, isCreate);
        });

        return fixedFields.filter(f => !f.system && !f.readonly && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
    }

    static FilterAndFixFieldsByWizardMode(mode: Wizard_Mode, fields: IField[]): IField[] {
        let filteredFields: IField[] = [];
        switch (mode) {


            case Wizard_Mode.Create:
            case Wizard_Mode.CreateFrom:
            case Wizard_Mode.Edit:
            case Wizard_Mode.Reload:
            case Wizard_Mode.PrintLabel:
                filteredFields = fields.filter(f => !f.readonly && !f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
                break;

            case Wizard_Mode.Acquired:
            case Wizard_Mode.Allocated:
                /// per avere prima i campi readonly e poi quelli editabili
                /// estraggo prima i readonly e poi gli editabili e poi li concateno
                let readOnlyFields = fields.filter(f => f.readonly && !f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
                let noReadOnlyFields = fields.filter(f => !f.readonly && !f.system && f.internalName !== 'Title' && f.internalName !== 'Titolario' && f.internalName !== 'Visibilita' && f.internalName !== 'Proprietario' && f.internalName !== 'Inoltro' && f.internalName !== 'CopiaConoscenza');
                filteredFields = [...readOnlyFields, ...noReadOnlyFields];
                break;
        }

        let fixedFields: IField[] = filteredFields?.map(f => {
            return this.fixInternalValueForClientView(f);

        });
        return fixedFields;
    }

    static fixInternalValueForCreateAndUpdateProtocol(field: IField, isCreate: boolean): IField {
        let newField: IField = { ...field };
        switch (field.controlType) {
            case "calendar":
                let dateTimeField = field as IDateTimeField;
                if (field.internalValue) {
                    //if (isCreate) {

                    //    const date = this.FieldFormatDateInUniversalString(dateTimeField);
                    //    newField = { ...dateTimeField, internalValue: date }

                    //}
                    //else {

                    newField = { ...dateTimeField }

                    //    }
                }
                else {
                    newField = { ...dateTimeField, internalValue: null }
                }
                break;

            case "dropdown":
                let choiceField = field as IChoiceField;
                if (field.internalValue) {

                    if (choiceField.multi) {

                        let choiceStringValue = choiceField.internalValue.join('; ');
                        newField = { ...choiceField, internalValue: choiceStringValue.trim() };

                    }
                    else {
                        newField = { ...choiceField, internalValue: choiceField.internalValue }
                    }
                }
                else if (!field.internalValue) {

                    newField = { ...choiceField, internalValue: null };
                }
                break;

            case "autocomplete":
                let lookupField = field as IAutocompleteField;

                if (lookupField.internalValue && lookupField.multi && lookupField.internalValue.length > 0) {

                    let lookupStringValue = '';
                    lookupField.internalValue.forEach(tag => {
                        lookupStringValue += tag.name + "; ";
                    });
                    newField = { ...lookupField, internalValue: lookupStringValue.trim() };

                }
                else if (lookupField.internalValue && !lookupField.multi && lookupField.internalValue.length > 0) {

                    let lookupValue = lookupField.internalValue[0].name;
                    newField = { ...lookupField, internalValue: lookupValue };

                }
                else if (!lookupField.internalValue || (lookupField.internalValue && lookupField.internalValue.length === 0)) {

                    newField = { ...lookupField, internalValue: null };

                }

                break;

            case "autocompleteUser":
                let userField = field as IUserField;


                if (userField.internalValue && userField.multi && userField.internalValue.length > 0) {

                    let userStringValue = '';
                    userField.internalValue.forEach(el => {
                        userStringValue += `${el.text} <${el.key}>; `;
                    });
                    newField = { ...userField, internalValue: userStringValue.trim() };

                }
                else if (userField.internalValue && !userField.multi && userField.internalValue.length > 0) {

                    let el = userField.internalValue[0];
                    newField = { ...userField, internalValue: `${el.text} <${el.key}>` };

                }
                else if (!userField.internalValue || (userField.internalValue && userField.internalValue.length === 0)) {

                    newField = { ...userField, internalValue: null };

                }

                break;
            case "autocompleteContact":

                let contactField = field as IAutocompleteField;


                if (contactField.internalValue && contactField.multi && contactField.internalValue.length > 0) {

                    let contactStringValue = '';
                    contactField.internalValue.forEach(el => {
                        contactStringValue += `${el.text} <${el.key}>; `;
                    });
                    newField = { ...contactField, internalValue: contactStringValue.trim() };

                }
                else if (contactField.internalValue && !contactField.multi && contactField.internalValue.length > 0) {

                    let el = contactField.internalValue[0];
                    newField = { ...contactField, internalValue: `${el.text} <${el.key}>` };

                }
                else if (!contactField.internalValue || (contactField.internalValue && contactField.internalValue.length === 0)) {

                    newField = { ...contactField, internalValue: null };

                }

                break;

            case "boolean":
                let newVal = field.internalValue === true || field.internalValue === 'true' || field.internalValue === 'True' ? 'true' : 'false';
                newField = { ...field, internalValue: newVal };

                break;

            case "textbox":
                if (field.sharepointType === 'Number' || field.sharepointType === "Currency") {

                    let newVal = Utilities.TryParseToNumber(field.internalValue);

                    newField = { ...field, internalValue: newVal };
                }
                break;

        }


        return newField;
    }

    static fixFieldsInternalValueForSearchSubmit(fields: IField[]): IField[] {
        const fixedFields = fields.map((item, index) => {
            return this.fixInternalValueForSearchSubmit(item);
        });

        return fixedFields;
    }

    static fixInternalValueForSearchSubmit(field: IField): IField {
        let newField: IField = { ...field };
        switch (field.controlType) {
            case "calendar":
                let dateTimeField = field as IDateTimeField;

                if (field.internalValue) {

                    const date = dateTimeField.internalValue;
                    const sortedDates = date.sort((a, b) => {
                        return a.getTime() - b.getTime();
                    });
                    newField = { ...dateTimeField, internalValue: sortedDates }
                }
                break;

            case "dropdown":
                let choiceField = field as IChoiceField;
                if (field.internalValue) {

                    if (choiceField.multi) {

                        newField = { ...choiceField };

                    }
                    else {

                        newField = { ...choiceField, internalValue: [choiceField.internalValue] }

                    }
                }
                break;

            case "autocomplete":
                let lookupField = field as IAutocompleteField;
                if (field.internalValue && field.internalValue.length > 0) {

                    let newInternalValue = lookupField.internalValue.map(tag => tag.name);
                    newField = { ...lookupField, internalValue: newInternalValue };

                }

                break;

            case "autocompleteUser":
                let userField = field as IUserField;
                if (field.internalValue) {

                    let newInternalValue = field.search_QueryOperator === Search_QueryOperator.Equals
                        ? userField.internalValue.map(el => `${el.text} <${el.key}>`)
                        : userField.internalValue.map(el => el.text);

                    newField = { ...userField, internalValue: newInternalValue };

                }

                break;

            case "autocompleteContact":

                let contactField = field as IAutocompleteField;
                if (field.internalValue) {

                    let newInternalValue = field.search_QueryOperator === Search_QueryOperator.Equals
                        ? contactField.internalValue.map(el => `${el.text} <${el.key}>`)
                        : contactField.internalValue.map(el => el.text);

                    newField = { ...contactField, internalValue: newInternalValue };

                }

                break;

            case "boolean":
                let newVal = field.internalValue === true || field.internalValue === 'true' || field.internalValue === 'True' ? 'true' : 'false';
                newField = { ...field, internalValue: newVal };

                break;

        }


        return newField;
    }



    static fixFieldsInternalValueForClientView(fields: IField[] | undefined): IField[] {
        let fixedFields: IField[] = [];

        if (fields) {
            fixedFields = fields.map((item, index) => {
                return this.fixInternalValueForClientView(item);
            });
        }
        return fixedFields;
    }

    static fixInternalValueForClientView(field: IField): IField {
        let newField: IField = { ...field };
        switch (field.controlType) {
            case "calendar":
                if (field.internalValue) {
                    let dateTimeField = field as IDateTimeField;
                    moment.locale('it');
                    var dateObjectd = moment(dateTimeField.internalValue);

                    let selectedDate: Date = dateObjectd.toDate();
                    newField = { ...dateTimeField, internalValue: selectedDate }
                }

                break;
            case "dropdown":
                if (field.internalValue) {

                    const choicefield = field as IChoiceField

                    let selectedValues;

                    if (choicefield.multi) {
                        selectedValues = []
                        if (choicefield.internalValue) {
                            let split = choicefield.internalValue.split(";");
                            split.forEach((el, index) => {
                                if (el) {
                                    selectedValues.push(el.trim());
                                }
                            });
                        }
                    }
                    else if (!choicefield.multi) {
                        selectedValues = "";
                        if (choicefield.internalValue) {
                            selectedValues = choicefield.internalValue;
                        }
                    }

                    newField = { ...choicefield, internalValue: selectedValues }


                }
                break;

            case "autocomplete":
                if (field.internalValue) {

                    let lookupField = field as IAutocompleteField;


                    let selectedTags: any[] = [];


                    if (lookupField.multi && lookupField.internalValue) {

                        let split = lookupField.internalValue.split(";");
                        split.forEach((el, index) => {
                            if (el) {
                                selectedTags.push({
                                    key: el.trim(),
                                    name: el.trim()
                                });
                            }
                        });
                    }
                    else if (lookupField.internalValue) {
                        selectedTags.push({
                            key: lookupField.internalValue,
                            name: lookupField.internalValue
                        });

                    }

                    newField = { ...lookupField, internalValue: selectedTags };

                }
                break;

            case "autocompleteUser":
                if (field.internalValue) {
                    let userField = field as IUserField;
                    let selectedUsers: any[] = this.parseUserInternalValueToPersona(userField.internalValue, false, false);
                    newField = { ...userField, internalValue: selectedUsers };
                }
                break;
            case "autocompleteContact":
                if (field.internalValue) {
                    let contactField = field as IAutocompleteField;
                    let selectedContacts: IPersonaProps[] = this.parseContactInternalValueToPersona(contactField.internalValue, false, false);
                    newField = { ...contactField, internalValue: selectedContacts };
                }
                break;
            case "boolean":
                if (field.internalValue) {
                    let value: boolean = field.internalValue === "True" || field.internalValue === "true" || field.internalValue === true ? true : false;
                    newField = { ...field, internalValue: value }

                }
                break;
        }

        return newField;
    }

    static fixFieldsValueForSearchEFSubmit = (fields: IField[]): IFilterEF[] => {
        const fixedFields = fields.map((item, index) => {
            return this.fixValueForSearchEFSubmit(item);
        });

        return fixedFields;
    }

    static fixValueForSearchEFSubmit = (field: IField): IFilterEF => {
        let fieldName = field.internalName;
        let fieldValue;
        let operator;

        switch (field.sharepointType) {
            case "Date":
                let dateTimeField = field as IDateTimeField;

                // quando avrò il filtro con da a nell'internal value dovrò inserire un array con i due valori
                if (field.internalValue) {

                    const date = dateTimeField.internalValue;
                    const sortedDates = date.sort((a, b) => {
                        return a.getTime() - b.getTime();
                    });
                    fieldValue = sortedDates;
                    operator = FilterEF_Operator.DateRanges;

                }

                break;

            case "Choice":
                let choiceField = field as IChoiceField;
                if (field.internalValue) {

                    if (choiceField.multi) {

                        fieldValue = { ...choiceField };
                        operator = FilterEF_Operator.Equals;

                    }
                    else {

                        fieldValue = choiceField.internalValue;
                        operator = FilterEF_Operator.Equals;
                    }
                }
                break;
            case "Number":
                fieldValue = Number(field.internalValue);
                operator = FilterEF_Operator.Equals;

                break;
            case 'Text':
                fieldValue = field.internalValue;
                operator = FilterEF_Operator.Contains;
                break;
            case 'User':
                let userField = field as IUserField;
                if (field.internalValue) {

                    let newInternalValue = userField.internalValue[0].key;
                    fieldValue = newInternalValue;
                    operator = FilterEF_Operator.Equals;

                }
                break;

            //    case "autocomplete":
            //        let lookupField = field as IAutocompleteField;
            //        if (field.internalValue && field.internalValue.length > 0) {

            //            let newInternalValue = lookupField.internalValue.map(tag => tag.name);
            //            newFilter = { ...lookupField, internalValue: newInternalValue };

            //        }

            //        break;

            //    case "autocompleteUser":
            //        let userField = field as IUserField;
            //        if (field.internalValue) {

            //            let newInternalValue = userField.internalValue.map(el => el.key);
            //            newFilter = { ...userField, internalValue: newInternalValue };

            //        }

            //        break;

            //    case "boolean":
            //        let newVal = field.internalValue === true || field.internalValue === 'true' || field.internalValue === 'True' ? 'true' : 'false';
            //        newFilter = { ...field, internalValue: newVal };

            //        break;
            default:
                fieldValue = field.internalValue;
                operator = FilterEF_Operator.Equals;
                break;
        }

        let newFilter: IFilterEF = {
            fieldName,
            fieldValue,
            operator
        }
        return newFilter;
    }


    static parseUserInternalValueToPersona = (internalValue: string, showSecondaryText: boolean, hidePersonaDetails: boolean): { key: string, text: string, showSecondaryText: boolean, hidePersonaDetails: boolean }[] => {
        const internalValueSplitArray = internalValue.split(';').filter(Boolean);
        const result: { key: string, text: string, showSecondaryText: boolean, hidePersonaDetails: boolean }[] = [];

        for (const userInfo of internalValueSplitArray) {
            const match = /([^<]+)<([^>]+)>/.exec(userInfo.trim());
            if (match) {
                const text = match[1].trim();
                const key = match[2].trim();
                result.push({ key, text, showSecondaryText, hidePersonaDetails });
            }
        }

        return result;
    }

    static parseContactInternalValueToPersona = (internalValue: string, showSecondaryText: boolean, hidePersonaDetails: boolean): IPersonaProps[] => {
        const internalValueSplitArray = internalValue.split(';').filter(Boolean);
        const result: IPersonaProps[] = [];

        for (const contactInfo of internalValueSplitArray) {
            const match = /([^<]+)<([^>]+)>/.exec(contactInfo.trim());
            if (match) {
                const text = match[1].trim();
                const key = match[2].trim();
                result.push({ key, text, showSecondaryText, hidePersonaDetails });
            }
            else {
                result.push({ key: contactInfo, text: contactInfo, showSecondaryText, hidePersonaDetails });
          }
        }

        return result;
    }

    static getDisplayValueFromFieldControlType = (field: IField) => {
        let displayValue = '-';
        switch (field.controlType) {
            case "calendar":
                displayValue = AppUtilities.FieldFormatDate(field);
                break;

            case "dropdown":
                displayValue = AppUtilities.FieldFormatChoice(field as IChoiceField);

                break;

            case "autocomplete":
                displayValue = AppUtilities.FieldFormatLookup(field as IAutocompleteField);

                break;

            case "autocompleteUser":
                displayValue = AppUtilities.FieldFormatUser(field);
                break;

            case "autocompleteContact":
                displayValue = AppUtilities.FieldFormatUser(field);
                break;

            case "boolean":
                displayValue = AppUtilities.FieldFormatBoolean(field);

                break;

            case 'textbox':
                switch (field.sharepointType) {

                    case 'Number':
                        displayValue = AppUtilities.FieldFormatNumber(field);
                        break;

                    case 'Currency':
                        displayValue = AppUtilities.FieldFormatCurrency(field as ICurrencyField);
                        break;

                    case 'Text':
                    default:
                        displayValue = field.internalValue ? field.internalValue : "-";
                        break;

                }
                break;

            case "textarea":
            default:
                displayValue = field.internalValue ? field.internalValue : "-";
                break;


        }

        return displayValue;
    }



    static checkFormFieldsValidity(formFields: IField[]): IField[] {


        const updatedFields = formFields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });

        return updatedFields;
    }

    static checkFieldValidity(field: IField): boolean {
        let isValid = false;

        if (field.required) {
            switch (field.controlType) {
                case "calendar":
                    const date = this.FieldFormatDate(field);
                    if (date !== '-')
                        isValid = true;
                    break;

                case "dropdown":
                    if (field.internalValue)
                        isValid = true;
                    break;

                case "dropdownMulti":
                    if (field.internalValue) {
                        let items: any[] = field.internalValue;
                        isValid = items.length > 0;
                    }
                    break;

                case "autocomplete":
                    // vedi Pickers Fluent ui
                    if (field.internalValue) {
                        let selectedTags: ITag[] = field.internalValue;
                        isValid = selectedTags.length > 0;
                    }
                    break;

                case "autocompleteUser":
                    // vedi PeoplePicker
                    if (field.internalValue) {
                        let selectedPersonas: any[] = field.internalValue;
                        isValid = selectedPersonas.length > 0;
                    }
                    break;
                case "autocompleteContact":
                    // vedi PeoplePicker
                    if (field.internalValue) {
                        let selectedPersonas: any[] = field.internalValue;
                        isValid = selectedPersonas.length > 0;
                    }
                    break;

                case "boolean":
                    isValid = true;
                    break;


                case "textbox":
                case "textarea":
                    let textField = field as ITextField;
                    if (textField.pattern) {
                        let valueToCheck = field.internalValue;
                        isValid = textField.pattern.test(valueToCheck);
                    }
                    else
                        isValid = field.internalValue ? field.internalValue.trim() !== '' : false;
                    break;


            }
        }
        /// se il campo non è required ma è valorizzato faccio il check sulla formattazione
        /// per esempio sulla data o sulle textbox verifico se devono soddisfare un determinato pattern
        else if (field.internalValue) {
            switch (field.controlType) {
                case "calendar":
                    const date = this.FieldFormatDate(field);
                    if (date !== '-')
                        isValid = true;

                    break;

                case "textbox":
                case "textarea":
                    let textField = field as ITextField;
                    if (textField.pattern) {
                        let valueToCheck = field.internalValue;
                        isValid = textField.pattern.test(valueToCheck);
                    }
                    else
                        isValid = true;

                    break;
                default:
                    isValid = true;
                    break;
            }
        }
        /// se il campo non è required e non è valorizzato allora è valido sicuramente
        else {
            isValid = true;
        }
        return isValid;
    }

    static checkTitolarioFieldValidity(required: boolean, internalValue): boolean {
        let isValid = false;

        if (required) {
            if (internalValue)
                isValid = true;

        }
        /// se il campo non è required e non è valorizzato allora è valido sicuramente
        else {
            isValid = true;
        }
        return isValid;
    }
    static getMessageFromErrorObjectValidity(errors: any): string {

        let message = '';

        let errorsKeysCount = Object.keys(errors).length;

        if (errorsKeysCount > 0) {


            Object.entries<string>(errors).forEach(([key, value], index) => {

                if (index == 0) {
                    message = value;
                }
                else if (index == errorsKeysCount - 1) {
                    message += " e " + value;
                }
                else {
                    message += ", " + value;

                }
            })
        }

        return Utilities.CapitalizeString(message);
    }



    static readonly extensionsAllowedForProtocolDocument: string[] = [
        '.docx',
        '.pdf',
        '.txt',
        '.jpeg',
        '.jpg',
        '.png',
        '.tif',
        '.tiff',
        '.p7m'
    ];
    static isExtensionAllowedForProtocolDocument(fileName: string): boolean {
        // Estrai l'estensione del file
        const fileNameParts = fileName.split('.');
        if (fileNameParts.length > 1) {
            let fileNameExtension = '.' + fileNameParts[fileNameParts.length - 1];
            switch (fileNameExtension.toUpperCase()) {
                case ".TIF":
                case ".TIFF":
                case ".JPG":
                case ".JPEG":
                case ".PNG":
                case ".DOCX":
                case ".TXT":
                    return true;
                case ".P7M":
                    const originalFileName = fileName.replace(/\.p7m$/, '');
                    return this.isExtensionAllowedForProtocolDocument(originalFileName);
                default:
                    return false;
            }
        }
        else {
            return false
        }
    }

    static extractOriginalFileNameFromP7M(fileName: string): string {
        const fileNameParts = fileName.split('.');
        if (fileNameParts.length > 1) {
            let fileNameExtension = ('.' + fileNameParts[fileNameParts.length - 1]).toLowerCase();
            if (fileNameExtension === '.p7m') {
                const originalFileName = fileName.replace(/\.p7m$/, '');
                return this.extractOriginalFileNameFromP7M(originalFileName)
            }
            else return fileName;
        }
        else return fileName;

    }

    static getExtensionFromFilename(filename: string) {
        let extension = "";
        if (filename) {
            var n = filename.lastIndexOf(".");
            extension = n > -1 ? filename.substr(n) : "";
            extension = extension.toLowerCase();
        }
        return extension;
    }



    static getFileIconFromExtension(extension: string) {
        if (!extension)
            return `https://static2.sharepointonline.com/files/fabric/assets/item-types/32/txt.png`;
        var n = extension.lastIndexOf(".");
        let docType = n > -1 ? extension.substr(n + 1) : extension;
        return `https://static2.sharepointonline.com/files/fabric/assets/item-types/32/${docType}.png`;
    }

    static compareFileEnableBeforeDisabled(a: IFile, b: IFile) {
        if (a.enabled && !b.enabled) {
            return -1;
        }
        else if (!a.enabled && b.enabled) {
            return 1;
        }
        else if (a.fileName.toUpperCase() < b.fileName.toUpperCase()) {
            return -1;
        }
        else if (a.fileName.toUpperCase() > b.fileName.toUpperCase()) {
            return 1;
        }
        // a must be equal to b
        return 0;
    }

    static instanceOfIField(object: any): object is IField {
        return Object.prototype.hasOwnProperty.call(object, "internalName")
            && Object.prototype.hasOwnProperty.call(object, "internalValue");
    }


    static convertToUnicode(input: string): string {
        let unicodeString = '';
        for (let i = 0; i < input.length; i++) {
            const charCode = input.charCodeAt(i);
            unicodeString += `\\u${charCode.toString(16).padStart(4, '0')}`;
        }
        return unicodeString;
    }


    static getUserVisibilitaForProtocol(visibilita: IVisibilita[], currentUser: IUser) {

        let userUor: IUor[] = currentUser.ruoliUorContext
            .map(el => el.uor!);


        let userVisibilitaForProtocol: IVisibilita[] = [];

        visibilita.forEach(el => {
            let uor = userUor.find(current => current.id === el.uor.id);
            if (uor) {
                el.uor = uor;
                userVisibilitaForProtocol.push(el);
            }

        });
        return userVisibilitaForProtocol;
    }

    static convertIProtocolToIProtocolEF(protocol: Partial<IProtocol>): Partial<IProtocolEF> | undefined {
        let protocolEF: Partial<IProtocolEF> | undefined = undefined;
        if (protocol) {
            protocolEF = {
                protocolSpId: protocol.id,
                numeroProtocollo: protocol.numeroProtocollo,
                annoProtocollo: protocol.annoProtocollo,
                dataProtocollo: protocol.dataProtocollo,
                statoProtocollo: protocol.statoProtocollo,
                tipoProtocollo: protocol.tipoProtocollo,

            }
        }
        return protocolEF;
    }

    static convertIProtocolEFToIProtocol(protocolEF: Partial<IProtocolEF>): Partial<IProtocol> | undefined {
        let protocol: Partial<IProtocol> | undefined = undefined;
        if (protocolEF) {
            protocol = {
                id: protocolEF.protocolSpId,
                numeroProtocollo: protocolEF.numeroProtocollo,
                annoProtocollo: protocolEF.annoProtocollo,
                dataProtocollo: protocolEF.dataProtocollo,
                statoProtocollo: protocolEF.statoProtocollo,
                tipoProtocollo: protocolEF.tipoProtocollo,

            };
        }
        return protocol;
    }


    static fieldsToJsonPatchDocument(fields: IField[]): any {
        let jsonPatchDocument: { op: string, path: string, value: any }[] = [];


        fields.forEach(field => {
            let internalName = field.internalName.replace('.', '/');
            jsonPatchDocument.push({
                op: "add",
                path: `/${internalName}`,
                value: field.internalValue

            });
        });
        return jsonPatchDocument;
    }
}


